module.exports = __webpack_public_path__ + "6399f62935ee5f163e66c9598df9b417.png";